import { render, staticRenderFns } from "./BrokersPage.html?vue&type=template&id=d6f1f70e&external"
import script from "./BrokersPage.js?vue&type=script&lang=js&external"
export * from "./BrokersPage.js?vue&type=script&lang=js&external"
import style0 from "./BrokersPage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports